import React from 'react'
import { BsX } from 'react-icons/bs'
import { motion } from 'framer-motion'
import { mobileRightMenuVariant } from '../../animations/mobileRightMenuVariant'
import LeftMenu from './LeftMenu'

const MobileHeaderRight = ({ handleShowRightMenu }) => {
    return (
        <div className='mobile-header-right'>
            <div className='close-x-btn' onClick={handleShowRightMenu}>
                <BsX size={25} />
            </div>
            <motion.div {...mobileRightMenuVariant} initial="initial" animate="animate" exit="exit" className='mobile-header-right-menu'>
                <LeftMenu closeModal={handleShowRightMenu} />
            </motion.div>
        </div>
    )
}

export default MobileHeaderRight
